import { Component, Input } from '@angular/core';
import { User } from '../../services/users/users.model';


export type RingColor = 'success' | 'warning' | 'danger' ;
export type Size = 'xs' | 'sm' | 'lg' | 'xl' ;

@Component({
  selector: 'app-avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css'
})
export class AvatarComponent {
  
  @Input()
  user?: User  ;

  @Input()
  size: Size = 'sm' ;

  @Input()
  ringColor?: RingColor ;

  get imgUrl(): string | undefined {

    if (!this.user || !this.user.profileImage) {
      return undefined ;
    }

    let url = this.user.profileImage ;
    if (!url.endsWith('/')) 
      url += '/';
  
    switch(this.size) {
      case "xl":
        return `${url}512.jpg` ;
      case "lg":
        return `${url}256.jpg` ;
      case "sm":
      case "xs":
        return `${url}128.jpg` ;
    }

    return "" ;
  }

  get initials(): string {
    if (!this.user) {
      return "" ;
    }

    return this.user.givenName.charAt(0) + this.user.familyName.charAt(0) ;
  }

  get sizeClass(): string {
    return "avatar-" + this.size ;
  }

  get classes(): string[] {

    const classes = ["avatar-" + this.size]

    if (this.ringColor == 'danger') {
      classes.push("border-danger", "border-4") ;
    } else if (this.ringColor == 'success') {
      classes.push("border-success", "border-4");
    } else if (this.ringColor == 'warning') {
      classes.push("border-warning", "border-4");
    } else {
      //classes.push("border-2") ;
    }

    return classes ;
  }

  get initialsClass(): string
  {

    switch( this.size) {
      case 'xs':
        return "text-xl" ;
      case 'sm':
        return "text-2xl" ;
      case 'lg':
        return "text-6xl" ;
      case 'xl':
        return "text-8xl" ;
    }

  }

}
